import React, { Component } from 'react'
import { api } from "../api";
import { connect } from 'react-redux'
import logoDarkBackground from '../dist/images/fw-logo-dark-background.svg';
import {withRouter} from "react-router-dom";


class LoginComponent extends Component {
	constructor( props ) {
		super( props );

		this.signInWithGoogle = this.signInWithGoogle.bind( this );
	}

	signInWithGoogle() {
		api.auth.signInWithGoogle();
	}

	componentWillReceiveProps(nextProps) {
		console.log( 'login', nextProps);
		if ( true === nextProps.auth.isAuthenticated ) {
			this.props.history.push('/app' );
		}
	}

	render() {
		return (
			<div className="grid-container fluid login">
				<div className="grid-y grid-padding-y grid-frame align-center-middle">
					<div className="cell">
						<div className="grid-container fluid">
							<div className="grid-y grid-margin-y grid-padding-y">
								<div className="cell">
									<div className="grid-x align-center">
										<div className="cell text-center medium-8">
											<img src={logoDarkBackground} alt=""/>
										</div>
									</div>
								</div>
								<div className="cell">
									<div className="grid-x align-center grid-padding-y grid-padding-x border-radius">
										<div className="cell text-center medium-4"
											 style={{background: '#fff', borderRadius: '5px'}}>
											<h1 style={{fontSize: 30, fontWeight: 'bold'}}>Inloggen</h1>
											<p>Voordat je toegang kunt krijgen tot dit systeem, dien je eerst in te
												loggen met je Google account van Frankwatching. Klik op de button
												hieronder om in te loggen.</p>
											<button onClick={this.signInWithGoogle} className="button collapse" href="#"
													style={{marginBottom: 0}}><i className="fab fa-google"></i> Inloggen
												met Google
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		auth: state.auth
	};
};

export default withRouter(connect(mapStateToProps)(LoginComponent));


// WEBPACK FOOTER //
// ./src/login/index.js